export const LINK_ACCOUNT_SUCCESS = 'LINK_ACCOUNT/SUCCESS';
export const LINK_ACCOUNT_REQUEST = 'LINK_ACCOUNT/REQUEST';
export const LINK_ACCOUNT_ERROR = 'LINK_ACCOUNT/ERROR';
export const LINK_ACCOUNT_CLEAR = 'LINK_ACCOUNT/CLEAR';
